import {Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {AuthErrorComponent} from './error/error.component';
import {CreatePasswordComponent} from './create-password/create-password.component';
import {SsoAppCallbackComponent} from './sso-app-callback/sso-app-callback.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    data: {
      meta: {
        title: 'Login',
        override: true,
        description: 'Login Page'
      }
    }
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    data: {
      meta: {
        title: 'Reset Password',
        override: true,
        description: 'Reset Password Page'
      }
    }
  },
  {
    path: 'create-password',
    component: CreatePasswordComponent,
    data: {
      meta: {
        title: 'Create Password',
        override: true,
        description: 'Create Password Page'
      }
    }
  },
  {
    path: 'error',
    component: AuthErrorComponent,
    data: {
      meta: {
        title: 'Authentication Error',
        override: true,
        description: 'Authentication Error Page'
      }
    }
  },
  {
    path: 'sso-app-callback',
    component: SsoAppCallbackComponent,
    data: {
      meta: {
        title: 'TeleGo App Login',
        override: true,
        description: 'TeleGo App Login Callback Page'
      }
    }
  },
];


